var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-label", style: { backgroundColor: _vm.color } },
    [
      _vm.icon
        ? _c("f-sprite-icon", { attrs: { "icon-link": _vm.icon } })
        : _vm._e(),
      _vm._v("\n  " + _vm._s(_vm.title) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }